import { Color } from "@sportactics/board-editing";

export type ColorDocument = {
  red: number;
  green: number;
  blue: number;
};

export function convertColorToDocument(color: Color): ColorDocument {
  return {
    red: color.red,
    green: color.green,
    blue: color.blue,
  };
}

export function convertDocumentToColor(colorModel: ColorDocument): Color {
  return new Color(colorModel.red, colorModel.green, colorModel.blue);
}
